export default {
    getCustomers: { method: 'get', url: 'emcadmin/customers' },
    postCustomers: { method: 'post', url: 'emcadmin/customers' },
    putCustomers: { method: 'put', url: 'emcadmin/customers/{id}' },
    deleteCustomers: { method: 'delete', url: 'emcadmin/customers/{id}' },
}
